<template>
    <div class="app">
        <div class="order-table" ref="orderTable">
            <ux-grid ref="table" widthResize show-overflow="title" :data="tableData" border stripe :height="uxGridHeight" max-height="100%" style="width: 100%" @cell-click="tableCellClick" v-loading="tableLoading" :row-class-name="tableRowClassName">
                <ux-table-column type="index" width="50" align="center" class-name="table-index" resizable>
                    <template slot="header">
                        <el-tooltip class="item" effect="dark" content="设置隐藏列(点击显示/隐藏)" placement="top">
                            <el-button icon="el-icon-s-tools" type="text" @click="getCustomColumns"></el-button>
                        </el-tooltip>
                    </template>
                </ux-table-column>
                <ux-table-column title="操作" align="center" width="80">
                    <template slot-scope="scope">
                        <el-button icon="el-icon-plus" type="text" :style="scope.rowIndex + 1 == tableData.length ? 'color: red' : ''" @click="addRow(scope.rowIndex + 1)"></el-button>
                        <el-button icon="el-icon-copy-document" type="text" @click="copyRow(scope)" style="margin: 0;"></el-button>
                        <el-button icon="el-icon-delete" type="text" style="margin: 0;" @click="deleteRow(scope)"></el-button>
                    </template>
                </ux-table-column>
                <ux-table-column title="商品" field="itemName" align="center" resizable min-width="180px">
                    <template slot-scope="scope">
                        <div v-if="scope.row.isShowItemName && !scope.row.planID">
                            <select-multiple :select-data="itemName" :optionKey="itemNameOptionKey" :isSlot="true" :isClear="false" :change="(val, row) => { itemNameChange(val, scope, from.billType == 'DBD' ? 'salUnitQty' : 'isLargessFormat') }" :visible-change="(val, row) => { itemNameVisibleChange(val, scope, from.billType == 'DBD' ? 'salUnitQty' : 'isLargessFormat') }" v-focus>
                                <template #header>
                                    <li class="el-select-group__title" style="color: #000; font-weight: bold; font-size: 14px;">
                                        <span style="width: 300px;display: inline-block;">商品</span>
                                        <span style="width: 100px;display: inline-block;">规格</span>
                                    </li>
                                </template>
                                <template v-slot:default='slotProps'>
                                    <div style="flex: 1; display: flex; align-items: center;">
                                        <span style="width: 300px;display: inline-block; overflow: hidden;">{{ slotProps.item.itemName }}</span>
                                        <span style="width: 100px;display: inline-block;">{{ slotProps.item.itemSpec }}</span>
                                    </div>
                                </template>
                            </select-multiple>
                        </div>
                        <div v-else>
                            <span>{{ scope.row.itemName }}</span>
                        </div>
                    </template>
                </ux-table-column>
                <ux-table-column key="invBarCode" title="条码" field="invBarCode" width="130" align="center" resizable v-if="customColumnList['invBarCode']">
                    <template slot-scope="scope">
                        <div v-if="scope.row.salBarCode">
                            <span>{{ scope.row.salBarCode }}</span><span>/大</span>
                        </div>
                        <div v-if="scope.row.midBarCode">
                            <span>{{ scope.row.midBarCode }}</span><span>/中</span>
                        </div>
                        <div v-if="scope.row.invBarCode">
                            <span>{{ scope.row.invBarCode }}</span><span>/小</span>
                        </div>
                    </template>
                </ux-table-column>
                <ux-table-column key="firstSecondType" field="firstSecondType" title="类别" v-if="customColumnList['firstSecondType']" align="center" min-width="120px" resizable></ux-table-column>
                <ux-table-column key="convertUnit" field="convertUnit" title="转换单位" v-if="customColumnList['convertUnit']" align="center" min-width="120px" resizable>
                    <template slot-scope="scope">
                        <p v-if="scope.row.salUnitConversion && scope.row.invUnitName && scope.row.salUnitName">1{{scope.row.salUnitName}}={{scope.row.salUnitConversion}}{{scope.row.invUnitName}}</p>
                        <p v-if="scope.row.midUnitConversion && scope.row.midUnitName && scope.row.invUnitName">1{{scope.row.midUnitName}}={{scope.row.midUnitConversion}}{{scope.row.invUnitName}}</p>
                    </template>
                </ux-table-column>
                <ux-table-column key="itemID" field="itemID" title="商品编号" v-if="customColumnList['itemID']" align="center" resizable width="100"></ux-table-column>
                <ux-table-column key="productionDate" title="生产日期" field="productionDate" align="center" resizable v-if="store.power.isEnableProductDate == 'Y' && customColumnList['productionDate']" width="100">
                    <template slot-scope="scope">
                        <div v-if="scope.row.isShowProductionDate && !scope.row.itemName">
                            <el-date-picker style="width: 100%;" v-focus @blur="scope.row.isShowProductionDate = false" value-format="yyyy-MM-dd" v-model="scope.row.productionDate" type="date" placeholder="选择生产日期">
                            </el-date-picker>
                        </div>
                        <span v-else>{{ scope.row.productionDate }}</span>
                    </template>
                </ux-table-column>
                <ux-table-column title="规格" field="itemSpec" width="100" align="center" resizable></ux-table-column>
                <ux-table-column key="isLargessFormat" title="销售形式" field="isLargessFormat" width="80" align="center" resizable v-if="from.billType == 'XSD'">
                    <template slot-scope="scope">
                        <div v-if="scope.row.isShowIsLargessFormat && !scope.row.planID">
                            <select-multiple :select-data="isLargessFormat" :isClear="false" :change="(val, row) => { isLargessChange(val, scope) }" :visible-change="(val, row) => { isLargessVisibleChange(val, scope) }" v-focus>
                            </select-multiple>
                        </div>
                        <span v-else @click="tableCellClick(scope.row, { property: 'salUnitQty' })">{{scope.row.isLargessFormat}}</span>
                    </template>
                </ux-table-column>
                <ux-table-column key="isLargessFormatCGD" title="采购形式" field="isLargessFormat" width="80" align="center" resizable v-if="from.billType == 'CGD'">
                    <template slot-scope="scope">
                        <div v-if="scope.row.isShowIsLargessFormat && !scope.row.planID">
                            <select-multiple :select-data="isLargessFormatCGD" :isClear="false" :change="(val, row) => { isLargessChange(val, scope) }" :visible-change="(val, row) => { isLargessVisibleChangeCGD(val, scope) }" v-focus>
                            </select-multiple>
                        </div>
                        <span v-else @click="tableCellClick(scope.row, { property: 'salUnitQty' })">{{scope.row.isLargessFormat}}</span>
                    </template>
                </ux-table-column>
                <ux-table-column key="salUnitQty" title="数量" align="center" width="140" resizable>
                    <template slot-scope="scope">
                        <div v-if="scope.row.itemName">
                            <span v-show="scope.row.salUnitName">
                                <el-input-number v-if="scope.row.isShowSalUnitQty && !scope.row.planID" style="width: 40px;" v-focus v-model.number="scope.row.salUnitQty" :controls="false" :min="0" :precision="2" @blur="numberInputBlur($event, scope, 'salUnitQty')" @keydown.enter.right.native="numberInputBlur('', scope, 'salUnitQty', scope.row.midUnitName ? 'midUnitQty' : (scope.row.salUnitConversion != 1 ? 'invUnitQty' : (scope.row.hideUnitPrice ? 'remark' : 'salUnitPrice')))"></el-input-number>
                                <span v-else style="min-width: 40px; display: inline-block; text-align: center;" @click="tableCellClick(scope.row, { property: 'salUnitQty' })">{{Number((Number(scope.row.salUnitQty) || 0).toFixedRoundUp(2))}}</span>
                                <span>{{scope.row.salUnitName}}</span>
                            </span>
                            <span v-show="scope.row.midUnitName">
                                <el-input-number v-if="scope.row.isShowMidUnitQty && !scope.row.planID" style="width: 40px;" v-focus v-model.number="scope.row.midUnitQty" :controls="false" :min="0" :precision="2" @blur="numberInputBlur($event, scope, 'midUnitQty')" @keydown.enter.right.native="numberInputBlur('', scope, 'midUnitQty', 'invUnitQty')" @keydown.left.native="numberInputBlur('', scope, 'midUnitQty', 'invUnitQty')"></el-input-number>
                                <span v-else style="min-width: 40px; display: inline-block; text-align: center;" @click="tableCellClick(scope.row, { property: 'midUnitQty' })">{{Number((Number(scope.row.midUnitQty) || 0).toFixedRoundUp(2))}}</span>
                                <span>{{scope.row.midUnitName}}</span>
                            </span>
                            <span v-show="scope.row.salUnitConversion != 1 && scope.row.invUnitName">
                                <el-input-number v-if="scope.row.isShowInvUnitQty && !scope.row.planID" style="width: 40px;" v-focus v-model.number="scope.row.invUnitQty" :controls="false" :min="0" :precision="2" @blur="numberInputBlur($event, scope, 'invUnitQty')" @keydown.enter.native="numberInputBlur('', scope, 'invUnitQty', scope.row.hideUnitPrice ? 'remark' : 'salUnitPrice')" @keydown.left.native="numberInputBlur('', scope, 'invUnitQty', scope.row.hideUnitPrice ? 'remark' : 'salUnitPrice')"></el-input-number>
                                <span v-else style="min-width: 40px; display: inline-block; text-align: center;" @click="tableCellClick(scope.row, { property: 'invUnitQty' })">{{Number((Number(scope.row.invUnitQty) || 0).toFixedRoundUp(2))}}</span>
                                <span>{{scope.row.invUnitName}}</span>
                            </span>
                        </div>
                    </template>
                </ux-table-column>
                <ux-table-column title="单价" align="center" width="140" resizable v-if="from.billType != 'DBD'">
                    <template slot-scope="scope">
                        <div v-if="scope.row.itemName">
                            <span v-show="scope.row.salUnitName">
                                <el-input-number v-if="scope.row.isShowSalUnitPrice && !scope.row.planID && !scope.row.hideUnitPrice && scope.row.priceRatio != '0'" style="width: 40px;" v-focus v-model.number="scope.row.salUnitPrice" :controls="false" :min="0" :precision="4" @blur="numberInputBlur($event, scope, 'salUnitPrice')" @change="handleSelect($event, scope, 'salUnitPrice', scope.row.midUnitName ? 'midUnitPrice' : (scope.row.salUnitConversion != 1 ? 'invUnitPrice' : 'remark'))" @keydown.enter.right.native="handleSelect('', scope, 'salUnitPrice', scope.row.midUnitName ? 'midUnitPrice' : (scope.row.salUnitConversion != 1 ? 'invUnitPrice' : 'remark'))"></el-input-number>
                                <span v-else style="min-width: 40px; display: inline-block; text-align: center;" @click="tableCellClick(scope.row, { property: 'salUnitPrice' })">{{Number(Number(scope.row.salUnitPrice || 0).toFixedRoundUp(4))}}</span>
                                <span>{{scope.row.salUnitName}}</span>
                            </span>
                            <span v-show="scope.row.midUnitName">
                                <el-input-number v-if="scope.row.isShowMidUnitPrice && !scope.row.planID && !scope.row.hideUnitPrice && scope.row.priceRatio != '0'" style="width: 40px;" v-focus v-model.number="scope.row.midUnitPrice" :controls="false" :min="0" :precision="4" @blur="numberInputBlur($event, scope, 'midUnitPrice')" @change="handleSelect($event, scope, 'midUnitPrice', 'invUnitPrice')" @keydown.enter.right.native="handleSelect('', scope, 'midUnitPrice', 'invUnitPrice')"></el-input-number>
                                <span v-else style="min-width: 40px; display: inline-block; text-align: center;" @click="tableCellClick(scope.row, { property: 'midUnitPrice' })">{{Number(Number(scope.row.midUnitPrice || 0).toFixedRoundUp(4))}}</span>
                                <span>{{scope.row.midUnitName}}</span>
                            </span>
                            <span v-show="scope.row.salUnitConversion != 1 && scope.row.invUnitName">
                                <el-input-number v-if="scope.row.isShowInvUnitPrice && !scope.row.planID && !scope.row.hideUnitPrice && scope.row.priceRatio != '0'" style="width: 40px;" v-focus v-model.number="scope.row.invUnitPrice" :controls="false" :min="0" :precision="2" @blur="numberInputBlur($event, scope, 'invUnitPrice')" @change="handleSelect($event, scope, 'invUnitPrice', 'remark')" @keydown.enter.right.native="handleSelect('', scope, 'invUnitPrice', 'remark')"></el-input-number>
                                <span v-else style="min-width: 40px; display: inline-block; text-align: center;" @click="tableCellClick(scope.row, { property: 'invUnitPrice' })">{{Number(Number(scope.row.invUnitPrice || 0).toFixedRoundUp(4))}}</span>
                                <span>{{scope.row.invUnitName}}</span>
                            </span>
                        </div>
                    </template>
                </ux-table-column>
                <ux-table-column field="amt" title="金额" align="center" width="120" resizable v-if="from.billType != 'DBD'"></ux-table-column>
                <ux-table-column resizable title="备注" field="remark" align="center" width="150">
                    <template slot-scope="scope">
                        <div v-if="scope.row.isShowRemark">
                            <el-input v-model="scope.row.remark" v-focus @blur="numberInputBlur($event, scope, 'remark')" @keydown.enter.native="numberInputBlur('', scope, 'remark', 'itemName')"></el-input>
                        </div>
                        <span v-else>{{scope.row.remark}}</span>
                    </template>
                </ux-table-column>
            </ux-grid>
        </div>
        <div class="main_footer">
            <span>共<span class="text">{{sum.total}}</span>条,<span v-if="from.billType != 'DBD'" class="text" style="font-size: 20px;">{{sum.totalAmt}}</span><span v-if="from.billType != 'DBD'">元，</span><span class="text">{{sum.billSalQty}}</span>大<span class="text">{{sum.billMedQty}}</span>中<span class="text">{{sum.billInvQty}}</span>小</span>
            <div>
                <el-button type="primary" size="medium" @click="submit(true)">提交</el-button>
                <el-button type="primary" size="medium" @click="submit(true, 'A')">提交并打印</el-button>
            </div>
        </div>
        <el-dialog title="自定义显示列" :visible.sync="dialogVisible" width="20%" @close="dialogClose">
            <custom-columns ref="customColumns" v-if="dialogVisible"></custom-columns>
        </el-dialog>
    </div>
</template>
<script>
import { toFixedRe, debounce } from '@/assets/js/common.js'
import customColumns from '@/components/common/customColumns.vue'
export default {
    props: {
        from: Object,
        power: Object,
    },
    components: {
        customColumns
    },
    data() {
        return {
            store: this.$store.state,
            tableData: this.pushItem(),
            itemName: {
                submitName: "itemName",
                selected: {},
                valueIsObj: true,
                isMultiple: false,
                isAll: false,
                isShowAll: false,
                isFilterable: true,
                isRemote: true,
                isPagination: true,
                isReSearch: false,
                isShowCheckbox: false,
                list: [],
                placeholder: "请选择商品",
                request: {
                    url: "/Account/dataSearchVue/selectItemEnterDetailList.html",
                    type: "post",
                    params: {
                        page: 1,
                        size: 5,
                        billType: 'XSD',
                        keyWords: ''
                    },
                    text: "itemName",
                    value: "itemID",
                },
            },
            isLargessFormat: {
                submitName: "isLargessFormat",
                selected: {},
                valueIsObj: true,
                isMultiple: false,
                isAll: false,
                isShowAll: false,
                isFilterable: true,
                isRemote: true,
                isPagination: true,
                isReSearch: false,
                list: [],
                placeholder: "请选择销售形式",
                request: {
                    url: "/Account/dataSearchVue/selectSalTypeList.html",
                    type: "post",
                    params: {
                        page: 1,
                        size: 5,
                    },
                },
            },
            isLargessFormatCGD: {
                submitName: "isLargessFormat",
                selected: {},
                valueIsObj: true,
                isMultiple: false,
                isAll: false,
                isShowAll: false,
                isFilterable: true,
                isRemote: true,
                isPagination: true,
                isReSearch: false,
                list: [],
                placeholder: "请选择采购形式",
                request: {
                    url: "/Account/dataSearchVue/selectLargessList.html",
                    type: "post",
                    params: {
                        page: 1,
                        size: 5,
                        billType: 'CGD',
                        onlyShowNormalAndLargess: 'Y'
                    },
                },
            },
            tableLoading: false,
            sum: {
                total: 0,
                totalAmt: 0,
                billInvQty: 0,
                billMedQty: 0,
                billSalQty: 0
            },
            customColumnsList: [{
                    label: "条码",
                    prop: "invBarCode"
                },
                {
                    label: "类别",
                    prop: "firstSecondType",
                },
                {
                    label: "转换单位",
                    prop: "convertUnit",
                },
                {
                    label: "商品编号",
                    prop: "itemID",
                },
                {
                    label: "生产日期",
                    prop: "productionDate",
                }
            ],
            customColumn: [],
            dialogVisible: false,
            uxGridHeight: 600,
        }
    },
    directives: {
        focus: {
            inserted: function(el) {
                el.querySelector('input').onfocus = function(e) {
                    e.currentTarget.select()
                }
                el.querySelector('input').focus()
            }
        }
    },
    mounted() {
        this.uxGridHeight = parseInt($('.order-table').css('height')) - 2
        window.onresize = () => {
            this.uxGridHeight = parseInt($('.order-table').css('height')) - 2
        }
    },
    computed: {
        customColumnList() {
            let tempItem = {}
            this.customColumn.forEach(i => {
                tempItem[i.prop] = (i.isShow == 'Y')
            })
            console.log(tempItem)
            return tempItem
        }
    },
    created() {
        this.getCustomColumnsList()
    },
    watch: {
        tableData(val) {
            let total = 0,
                amt = 0,
                sal = 0,
                mid = 0,
                inv = 0
            val.forEach((item, index) => {
                item['lineNum'] = index + 1
                if (item.itemID) {
                    total += 1
                    console.log(item.amt, 22222)
                    amt += Number(item.amt || 0)
                    sal += Number(item['salUnitQty'] || 0)
                    mid += Number(item['midUnitQty'] || 0)
                    inv += Number(item['invUnitQty'] || 0)
                }
            })
            this.sum.total = total
            this.sum.totalAmt = Number(toFixedRe(amt, 2))
            this.sum.billInvQty = Number(toFixedRe(inv, 2))
            this.sum.billMedQty = Number(toFixedRe(mid, 2))
            this.sum.billSalQty = Number(toFixedRe(sal, 2))
        }
    },
    methods: {
        getHeight() {
            this.uxGridHeight = parseInt($('.order-table').css('height')) - 2
        },
        pushItem(length = 20) {
            const tempItem = []
            for (let i = 0; i < length; i++) {
                tempItem.push({})
            }
            return tempItem
        },
        itemNameOptionKey(item) {
            return item.itemID + item.productionDate
        },
        itemNameVisibleChange(val, { row, column }, next) {
            if (!val) {
                this.$set(row, 'isShow' + this.titleCase(column.property), false)
                this.tableCellClick(row, { property: next })
            } else {
                console.log(row)
                this.itemName.placeholder = row.itemName
                this.itemName.selected = { text: row.itemName, value: row.itemID }
                if (column.property == 'itemName') {
                    let flag = false
                    console.log(this.power.isAgreementDoubleItem)
                    if (this.power.isAgreementDoubleItem == 'Y') {
                        flag = this.checkRepeat({}, next, true)
                    }
                    if (flag) {
                        this.$set(row, 'isShow' + this.titleCase(column.property), false)
                    }
                }
            }
            this.itemName.request.params.page = 1
        },
        isLargessVisibleChange(val, { row, column }) {
            if (!val) {
                this.$set(row, 'isShow' + this.titleCase(column.property), false)
                this.tableCellClick(row, { property: 'salUnitQty' })
            } else {
                this.isLargessFormat.placeholder = row.isLargessFormat
                this.isLargessFormat.selected = { text: row.isLargessFormat, value: row.isLargess }
            }
            this.isLargessFormat.request.params.page = 1
        },
        isLargessVisibleChangeCGD(val, { row, column }) {
            if (!val) {
                this.$set(row, 'isShow' + this.titleCase(column.property), false)
                this.tableCellClick(row, { property: 'salUnitQty' })
            } else {
                this.isLargessFormatCGD.placeholder = row.isLargessFormat
                this.isLargessFormatCGD.selected = { text: row.isLargessFormat, value: row.isLargess }
            }
            this.isLargessFormatCGD.request.params.page = 1
        },
        async itemNameChange(val, { rowIndex: $index, row }, next) {
            let rowIndex = 0
            let tempArr = this.tableData.filter((i, index) => {
                if (this.itemNameOptionKey(i) == this.itemNameOptionKey(val)) {
                    rowIndex = index + 1
                    return true
                }
            })
            if (this.from.billType == 'DBD') {
                val.hideUnitPrice = true
            }
            let confirmResult = ''
            console.log(tempArr)
            if (tempArr.length) {
                const h = this.$createElement
                confirmResult = await this.$msgbox({
                    title: '提示',
                    message: h('p', null, [
                        h('i', { style: 'color: teal' }, tempArr[0].itemName),
                        h('span', null, '第'),
                        h('i', { style: 'color: #F56C6C' }, rowIndex),
                        h('span', null, '行已经录入，是否合并?')
                    ]),
                    showCancelButton: true,
                    confirmButtonText: '合并',
                    cancelButtonText: '追加',
                    type: 'warning'
                }).catch(err => err)
            }
            console.log(confirmResult)
            if (confirmResult == '' || confirmResult == 'cancel') {
                if (next == 'isLargessFormat') {
                    this.isLargessFormat.request.params.itemID = val.itemID
                    this.isLargessFormat.request.params.customerID = this.from.customerID
                    this.isLargessFormatCGD.request.params.itemID = val.itemID
                    this.isLargessFormatCGD.request.params.customerID = this.from.customerID
                }
                this.$set(this.tableData, $index, { ...row, ...val })
                this.$set(this.tableData[$index], 'isShowItemName', false)
                this.tableCellClick(this.tableData[$index], { property: next })
            } else if (confirmResult == 'confirm') {
                this.isLargessFormat.request.params.itemID = val.itemID
                this.isLargessFormat.request.params.customerID = this.from.customerID
                this.isLargessFormatCGD.request.params.itemID = val.itemID
                this.isLargessFormatCGD.request.params.customerID = this.from.customerID
                this.tableCellClick(tempArr[0], { property: 'salUnitQty' })
            }
        },
        isLargessChange(val, { rowIndex: $index, row }) {
            val.isLargessFormat = val.text
            val.isLargess = val.value
            if (val.value == 'L' || val.value == 'D') { // L表示为赠品
                val.hideUnitPrice = true
            } else {
                val.hideUnitPrice = false
            }
            val.isShowIsLargessFormat = false
            this.$set(this.tableData, $index, { ...row, ...val })
            this.tableCellClick(this.tableData[$index], { property: 'salUnitQty' })
        },
        numberInputBlur($event, { rowIndex: $index, row }, property, next) {
            if (property.match(/salUnitPrice|midUnitPrice|invUnitPrice|salUnitQty|midUnitQty|invUnitQty/i)) {
                this.amt(row)
            }
            row['isShow' + this.titleCase(property)] = false
            this.$set(this.tableData, $index, row)
            // this.$refs['table'].updateData()
            if (next) {
                if (property == 'remark') {
                    if (this.tableData[$index + 1]) {
                        this.tableCellClick(this.tableData[$index + 1], { property: next })
                    }
                    return false
                }
                this.tableCellClick(row, { property: next })
            }
        },
        addRow(index) {
            if (index === this.tableData.length) {
                this.tableData = this.tableData.concat(this.pushItem(10))
            } else {
                // this.tableData.push({})
                this.tableData.splice(index, 0, {})
            }
        },
        copyRow({ $index, row, column }) {
            if (!row.itemName) return
            if (row.planID) return this.$message({
                showClose: true,
                message: '促销商品不允许复制',
                type: 'warning'
            })
            this.tableData.some((item, index) => {
                if (index >= $index) {
                    if (!item.itemName) {
                        this.$set(this.tableData, index, { ...row }) // 解决两份数据来源一样时，会使两行同时处于编辑状态的bug({ ...row } 是深度复制，row 是引用，指针相同)
                        return true
                    }
                }
            })
        },
        async deleteRow({ rowIndex: $index, row }) {
            if (this.tableData.length <= 1) return
            const confirmResult = await this.$confirm('此操作为删除操作, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).catch(err => err)
            if (confirmResult !== 'confirm') return this.$message.info('取消删除')
            this.$nextTick(() => {
                // let $queryForm = this.$parent.$children[0]
                // console.log(this.itemNameOptionKey(row))
                // $queryForm.selectProductList = $queryForm.selectProductList.filter(i => this.itemNameOptionKey(i) != this.itemNameOptionKey(row))
                if (row.planID) {
                    this.tableData = this.tableData.filter(item => item.planID != row.planID)
                } else {
                    this.tableData.splice($index, 1)
                }
            })
        },
        tableRowClassName({ row }) {
            if (row.planID) {
                return 'plan-row'
            }
            return ''
        },
        async getCustomColumnsList() {
            const { data: res } = await this.$http.post(
                "Account/dataSearchVue/selectColumnByFuncCode.html",
                this.Qs.stringify({ funcCode: 221 })
            );
            if (res.code != "success")
                return this.$confirm(res.message, "提示", {
                    confirmButtonText: "确定",
                    showCancelButton: false,
                    type: "error",
                });
            let result = JSON.parse(res.result);
            let tempArr = [];
            let arr = [];
            this.customColumnsList.some((item) => {
                if (item.power && !item.power.every((row) => this.power[row] == "Y"))
                    return false;
                if (item.children) {
                    item.children = this.customColumnsFilterOfPower(item.children);
                }
                tempArr.push(item);
            });
            tempArr.forEach((item) => {
                result.forEach(($item) => {
                    if (item.prop == $item.prop) {
                        if (item.children && item.children.length) {
                            arr.push({
                                id: $item.id,
                                label: item.label,
                                prop: item.prop,
                                isShow: $item.isShow,
                                children: this.mergeArr(item.children, $item.children, "prop"),
                            });
                        } else {
                            arr.push({
                                id: $item.id,
                                label: item.label,
                                prop: item.prop,
                                isShow: $item.isShow,
                            });
                        }
                    }
                });
            });
            this.customColumn = [...arr]
        },
        getCustomColumns() {
            this.dialogVisible = true
            let tempArr = [...this.customColumn]
            this.$nextTick(() => {
                let element = this.$refs['customColumns']
                element.loading = false
                element.setCustomcolumns(tempArr)
            })
        },
        dialogClose() {
            let $customColumns = this.$refs['customColumns']
            $customColumns.$nextTick(async () => {
                let { customColumns } = $customColumns
                const { data: res } = await this.$http.post('/Account/customerColumnDefineVue/saveColAndAuthByFuncCode.html', this.Qs.stringify({
                    funcCode: 221,
                    customSetInfo: JSON.stringify(customColumns)
                }))
                if (res.code != 'success') return this.$message.error(res.message)
                this.$message.success(res.message)
            })
            console.log(this.customColumn)
            this.$nextTick(() => {
                this.$refs["table"].updateData();
            })
        },
        tableCellClick(row, { property }) {
            console.log(this.from)
            if (row.itemName || property == 'itemName') {
                if (property && property.match(/itemName|isLargessFormat|salUnitPrice|midUnitPrice|invUnitPrice|salUnitQty|midUnitQty|invUnitQty|remark|productionDate/i)) {
                    if (!this.from.billDate || this.from.billDate == '') return this.$message({
                        showClose: true,
                        message: '请先选择单据日期',
                        type: 'warning'
                    })
                    if ((!this.from.customerID || this.from.customerID == '') && this.from.billType != 'DBD') return this.$message({
                        showClose: true,
                        message: '请先选择客户',
                        type: 'warning'
                    })
                    if (!this.from.salesmanID || this.from.salesmanID == '') return this.$message({
                        showClose: true,
                        message: '请先选择业务员',
                        type: 'warning'
                    })
                    if (!this.from.warehouseID || this.from.warehouseID == '') return this.$message({
                        showClose: true,
                        message: '请先选择' + (this.from.billType == 'CGD' ? '入库' : '出库') + '库房',
                        type: 'warning'
                    })
                    if ((!this.from.inWarehouseID || this.from.inWarehouseID == '') && this.from.billType == 'DBD') return this.$message({
                        showClose: true,
                        message: '请先选择入库库房',
                        type: 'warning'
                    })
                    this.itemName.request.params.warehouseID = this.from.warehouseID
                    this.itemName.request.params.customerID = this.from.customerID
                    this.itemName.request.params.inWarehouseID = this.from.inWarehouseID
                    if (this.from.billType == 'XSD' && property == 'isLargessFormat') {
                        this.isLargessFormat.request.params.page = 1
                        this.isLargessFormat.request.params.keyWords = ''
                        this.isLargessFormat.request.params.warehouseID = this.from.warehouseID
                        this.isLargessFormat.request.params.itemID = this.itemName.selected.itemID
                    } else if (this.from.billType == 'CGD' && property == 'isLargessFormat') {
                        this.isLargessFormatCGD.request.params.page = 1
                        this.isLargessFormatCGD.request.params.keyWords = ''
                        this.isLargessFormatCGD.request.params.warehouseID = this.from.warehouseID
                        this.isLargessFormatCGD.request.params.itemID = this.itemName.selected.itemID
                    }
                    this.$set(row, 'isShow' + this.titleCase(property), true)
                    // this.$refs['table'].doLayout()
                }
            }
        },
        // 首字母大写
        titleCase(str) {
            return str.replace(/( |^)[a-z]/g, (L) => L.toUpperCase())
        },
        customerSelect(val) {
            if (val.value) {
                let { productArgs, $refs } = this.$root
                this.$nextTick(() => {
                    productArgs.customerID = val.value
                    this.$refs['inWarehouse'].$children[0].focus()
                    let { orderCascader } = $refs
                    orderCascader.getBrandData()
                })
            }
        },
        async querySearch(queryString, cb, { row }) {
            const { data: res } = await this.$http.post('/Account/salConsignVue/selectSalPriceListForVue.html', this.Qs.stringify({ itemID: row.itemID, customerID: this.from.customerID }))
            res.result = JSON.parse(res.result)
            cb(JSON.parse(res.result.data))
        },
        handleSelect(val, scope, property, next) {
            if (next) {
                this.numberInputBlur('', scope, property, next) // 先失焦，在赋值，是为了与mousedown事件保持同样的触发时机；不要改变顺序（除非你可以解决input框blur事件比click先触发的问题）
            }
            let { $index, row } = scope
            if (val) {
                val = toFixedRe(val, 4)
                this.$set(row, property, val)
            }
            this.computeUnitPrice(property, row, $index)
        },
        computeUnitPrice(property, row, $index) {
            let { salUnitPrice, midUnitPrice, invUnitPrice, salUnitConversion, midUnitConversion, invUnitConversion } = row
            if (property == 'salUnitPrice') {
                midUnitPrice = Number(toFixedRe(((Number(salUnitPrice) || 0) / Number(salUnitConversion) * Number(midUnitConversion)), 4)).toString()
                invUnitPrice = Number(toFixedRe(((Number(salUnitPrice) || 0) / Number(salUnitConversion)), 4)).toString()
            } else if (property == 'midUnitPrice') {
                salUnitPrice = Number(toFixedRe(((Number(midUnitPrice) || 0) / Number(midUnitConversion) * Number(salUnitConversion)), 4)).toString()
                invUnitPrice = Number(toFixedRe(((Number(midUnitPrice) || 0) / Number(midUnitConversion)), 4)).toString()
            } else if (property == 'invUnitPrice') {
                salUnitPrice = Number(toFixedRe(((Number(invUnitPrice) || 0) * Number(salUnitConversion)), 4)).toString()
                midUnitPrice = Number(toFixedRe(((Number(invUnitPrice) || 0) * Number(midUnitConversion)), 4)).toString()
            }
            row.salUnitPrice = salUnitPrice
            row.midUnitPrice = midUnitPrice
            row.invUnitPrice = invUnitPrice
            this.$refs['table'].$nextTick(() => {
                this.$set(this.tableData, $index, row)
            })
        },
        checkRepeat({ $index, row }, next, isCheck = false) {
            let flag = false
            const checkFn = ($index, row) => {
                let checked = false
                try {
                    this.tableData.forEach((item, index) => {
                        const h = this.$createElement
                        let htmlNode = [
                            h('i', { style: 'color: teal' }, item.itemName),
                            h('span', null, '第'),
                            h('i', { style: 'color: #F56C6C' }, item.lineNum),
                            h('span', null, '行已经录入，是否合并?')
                        ]
                        if (isCheck) {
                            checked = row.itemID && index != $index && (('' + item.itemID + item.isLargess + item.productionDate + item.flavorID) == ('' + row.itemID + row.isLargess + row.productionDate + row.flavorID))
                            htmlNode.unshift(h('span', null, '行的'))
                            htmlNode.unshift(h('i', { style: 'color: #F56C6C' }, $index + 1))
                            htmlNode.unshift(h('span', null, '第'))
                        } else {
                            checked = row.itemID && index != $index && ((item.itemID) == (row.itemID))
                        }
                        if (checked) {
                            flag = true
                            if (top.indexVm.$store.state.power.isAgreementDoubleItem == 'Y') {
                                this.$msgbox({
                                    title: '提示',
                                    message: h('p', null, htmlNode),
                                    showCancelButton: !isCheck,
                                    confirmButtonText: '合并',
                                    cancelButtonText: '追加',
                                    type: 'warning'
                                }).then(() => {
                                    this.isLargessFormat.request.params.itemID = row.itemID
                                    this.isLargessFormat.request.params.customerID = this.from.customerID
                                    this.$set(this.tableData, $index, {})
                                    this.tableCellClick(this.tableData[index], { property: 'salUnitQty' })
                                }).catch(() => {
                                    this.isLargessFormat.request.params.itemID = row.itemID
                                    this.isLargessFormat.request.params.customerID = this.from.customerID
                                    if (isCheck) {
                                        this.$set(this.tableData, $index, {})
                                        this.tableCellClick(this.tableData[index], { property: 'salUnitQty' })
                                        return false
                                    }
                                    this.tableCellClick(this.tableData[$index], { property: next })
                                })
                            } else {
                                row.isMerge = true
                                row.mergeIndex = item.lineNum
                                console.log(row)
                                this.$message({
                                    showClose: true,
                                    message: `${item.itemName}在第${item.lineNum}行已经录入`,
                                    type: 'warning'
                                });
                                this.isLargessFormat.request.params.itemID = row.itemID
                                this.isLargessFormat.request.params.customerID = this.from.customerID
                                row['isShow' + this.titleCase(next)] = true
                                // this.tableCellClick(this.tableData[$index], { property: next })
                            }
                            throw item
                        }
                    })
                } catch (e) {}
            }
            if (isCheck) {
                this.tableData.forEach(($$item, $$index) => {
                    checkFn($$index, $$item)
                })
            } else {
                checkFn($index, row)
            }
            return flag
        },
        amt(row) {
            let str = ''
            if (row['salUnitQty'] || row['midUnitQty'] || row['invUnitQty']) {
                let sal = (Number(row['salUnitQty']) || 0) * (Number(row['salUnitPrice']) || 0)
                let mid = (Number(row['midUnitQty']) || 0) * (Number(row['midUnitPrice']) || 0)
                let inv = (Number(row['invUnitQty']) || 0) * (Number(row['invUnitPrice']) || 0)
                str = Number(toFixedRe(sal + mid + inv, 2))
                row['amt'] = str
            } else {
                row['amt'] = 0
            }
            return str
        },
        async submit(isDraft, command) {
            let obj = {
                headInfo: JSON.stringify({ ...this.from, ...this.sum }),
                billType: this.from.billType,
                billDate: this.from.billDate
            }
            if (this.sum.total == 0) return this.$message({
                showClose: true,
                message: '请录入商品',
                type: 'error'
            })
            let flag = false
            let tableData = []
            this.tableData.map((i, index) => {
                if (i.itemID) {
                    console.log(i.amt)
                    tableData.push(i)
                }
            })
            tableData.some(item => {
                const { itemID, salUnitQty, midUnitQty, invUnitQty, lineNum } = item
                console.log(itemID, salUnitQty, midUnitQty, invUnitQty)
                if (itemID && Number(salUnitQty) + Number(midUnitQty) + Number(invUnitQty) == 0) {
                    this.$message({
                        showClose: true,
                        message: '第' + lineNum + '行,商品数量不能为零',
                        type: 'error'
                    })
                    flag = true
                    return true
                }
            })
            if (flag) return
            obj.itemList = JSON.stringify(tableData)
            console.log(obj)
            let url = '/Account/supplementOrderVue/addSupplementOrder.html'
            let currTab = '',
                title = ''
            if (top.$('#tabspanel .tabs-selected').text()) {
                currTab = top.$('#tabspanel').tabs('getSelected') || ''
                title = top.$('#tabspanel .tabs-selected').text() || ''
            } else {
                title = top.getTabName()
                currTab = top.getTabName()
            }
            const loading = this.$loading({
                lock: true,
                text: '记账中，请耐心等待',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            })
            const { data: res } = await this.$http.post(url, this.Qs.stringify(obj))
            loading.close()
            if (res.code != 'success') return this.$message.error(res.message)
            if (command == 'A') {
                let billNo = JSON.parse(JSON.parse(res.result).data).billNo
                let billTpe = JSON.parse(JSON.parse(res.result).data).billTpe
                console.log(billNo)
                let url = ''
                if (billTpe == 'XSD') {
                    billNo = "'" + billNo + "'"
                    url = `/Account/salConsignVue/printSalConsignList.html?billNo=${ billNo }&billType=A`
                } else if (billTpe == 'CGD') {
                    url = `/Account/purchaseInStockVue/Print.html?billNo=${ billNo }&billType=A`
                } else {
                    url = `/Account/InvMoveVue/printInvMoveDetail.html?billNo=${ billNo }`
                }
                window.open(url, '_blank', "width=1011,height=680,left=300,top=150,toolbar=no,menubar=no,scrollbars=yes,resizable=yes,location=no")
            }
            this.$message.success(res.message)
            setTimeout(() => {
                top.refreshTabWithUrl(`/templates/vue-account/dist/index.htm#/supplementIndex`, currTab)
            }, 500)
        },
        resetTable() {
            this.tableData = this.pushItem()
            console.log(this.pushItem())
            this.$refs['table'].updateData()
        },
    }
}
</script>
<style scoped lang="less">
.app {
    height: calc(100% - 105px);

    .order-table {
        width: 100%;
        height: calc(100% - 45px - 12px);

        ::v-deep .elx-cell {
            padding: 0;
        }

        ::v-deep .elx-table {

            .elx-body--column,
            .elx-footer--column.col--ellipsis {
                height: 39px;
            }

            .elx-body--column.col--ellipsis>.elx-cell,
            .elx-footer--column.col--ellipsis>.elx-cell {
                max-height: 70px;
                white-space: normal;
                color: #000;
            }

            .table-index {
                font-size: 12px;
            }

            th,
            td,
            .cell {
                padding: 0;
            }

            thead {
                color: #000;
            }

            .el-input-number.is-without-controls .el-input__inner,
            .el-input-number .el-input__inner,
            .el-autocomplete .el-input__inner {
                padding: 0;
                text-align: left;
            }
        }
    }

    .main_footer {
        height: 45px;
        display: flex;
        align-items: center;

        .text {
            color: #F56C6C;
            padding: 0 4px;
        }

        span {
            width: 50%;
        }

        div {
            transform: translate(-50%, 0);
        }
    }

    ::v-deep .el-dialog {
        .el-dialog__body {
            padding: 16px 12px 0;
        }

        .el-dialog__footer {
            text-align: center;
        }
    }

    .reference {
        cursor: pointer;
    }

    .reference.highlight label {
        color: #409EFF;
    }
}

.query_btn_group {
    display: flex;

    .el-button {
        margin-left: 6px;
        color: #606266;

        &:hover {
            color: #409EFF;
        }
    }
}
</style>